<div class="row mb-3">
  <div class="col-md-3 col-12 no-wrap">
    <strong>
      {{ timeSlot.start | cetDate: 'HH:mm' }}
      @if (!undefinedEnd && timeSlot.end) {
        <span> - {{ timeSlot.end | cetDate: 'HH:mm' }}</span>
      }
      @if (undefinedEnd && undefinedEndString) {
        <span> - {{ undefinedEndString | translate }}</span>
      }
    </strong>
  </div>
  <div class="col-md-9 col-12">
    {{ message | translate }}{{ additionalString }}
  </div>
</div>
